import * as Config from "@/config";
import { InputDefaultRows } from "@/containers/data/Attributes/AttributeInput";
import { useProjectStore } from "@/stores/project";
import React from "react";
import { MapInputContainer } from "./MapInputContainer";
import PidInputRows from "./PidInputRows";

interface InputTablesProps {
  isType: Config.Data;
  attributes: Array<any>;
  chooseComponent?: (attr: any, isType: Config.Data) => React.ReactNode;
  dataMap?: Map<string, any>;
  areas: any[];
  blocks: any[];
  areaName: string;
  blockName: string;
}

const InputTables: React.FC<InputTablesProps> = ({
  isType,
  attributes,
  chooseComponent,
  dataMap,
  areas,
  blocks,
  areaName,
  blockName,
}) => {
  const [selectedProjectCategory] = useProjectStore((state) => [
    state.project,
    state.projectCategory,
  ]);
  return (
    <>
      <div className="map-area-box">
        <table
          className="uk-table uk-table-small uk-width-1-2"
          style={{
            marginTop: 0,
            borderCollapse: "collapse",
            verticalAlign: "top",
          }}
        >
          <tbody>
            <InputDefaultRows
              isType={isType}
              attributes={attributes}
              selectedProjectCategory={selectedProjectCategory}
              dataMap={dataMap}
              areas={areas}
              blocks={blocks}
              areaName={areaName}
              blockName={blockName}
            />
          </tbody>
        </table>

        <div className="map-input-container uk-width-1-2">
          <MapInputContainer
            isType={isType}
            attributes={attributes}
            chooseComponent={chooseComponent}
          />
        </div>
      </div>

      <table
        className="uk-table uk-table-small"
        style={{ borderCollapse: "collapse" }}
      >
        <tbody>
          <PidInputRows isType={isType} attributes={attributes} />
        </tbody>
      </table>
    </>
  );
};

export default InputTables;
